import { render, staticRenderFns } from "./NotificacoesConvites.vue?vue&type=template&id=169832d7&scoped=true"
import script from "./NotificacoesConvites.vue?vue&type=script&lang=js"
export * from "./NotificacoesConvites.vue?vue&type=script&lang=js"
import style0 from "./NotificacoesConvites.vue?vue&type=style&index=0&id=169832d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "169832d7",
  null
  
)

export default component.exports